// Anonymes Web-Vitals-Logging (LCP/CLS/INP/FCP/TTFB).
// Sendet Kennzahlen per sendBeacon an das Backend – keine personenbezogenen Daten.
// Admin-Seiten (/admin) werden bewusst NICHT gemessen.
import { onLCP, onCLS, onINP, onFCP, onTTFB } from "web-vitals";

const ENDPOINT = `${process.env.REACT_APP_BACKEND_URL}/api/vitals`;

function send(metric) {
  const path = window.location.pathname;
  if (path.startsWith("/admin")) return;
  const body = JSON.stringify({
    name: metric.name,
    value: metric.value,
    rating: metric.rating,
    id: metric.id,
    navigation_type: metric.navigationType,
    path,
  });
  try {
    if (navigator.sendBeacon) {
      navigator.sendBeacon(ENDPOINT, new Blob([body], { type: "application/json" }));
    } else {
      fetch(ENDPOINT, {
        method: "POST",
        body,
        headers: { "Content-Type": "application/json" },
        keepalive: true,
      });
    }
  } catch {
    /* Messung darf niemals die Seite beeinflussen */
  }
}

export function reportWebVitals() {
  onLCP(send);
  onCLS(send);
  onINP(send);
  onFCP(send);
  onTTFB(send);
}
